import axios from 'axios';
import { API } from '../api/apiList';
const apiDetails = API.find((API) => API.name === 'analytics');

export const fetchTotalVisits = async () => {
  try {
    const response = await axios.get(apiDetails.getVisit, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });

    return response.data.data.visits_data;
  } catch (error) {
    console.error('Error fetching Matomo data:', error);
    return null;
  }
};
